// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2O3_I","productName":"Table_productName__1uBVP"};